import React from 'react';

const DiscountMessage = ({ discounts, localisations }) =>
  discounts.percentage && !discounts.promo_code ? (
    <p className="products__discount-message">
      <strong>{localisations.renew_today} {discounts.percentage}% {localisations.discount}</strong>
    </p>
  ) : null;

export default DiscountMessage;
